import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const DocumentsIcon = ({ size }: IconSvgProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Brand Icons/Documents" clipPath="url(#clip0_5565_6299)">
                <g id="Vector">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.9993 8.5H20.9993L29.9993 17.5V33.5H10.9993V8.5ZM18.9993 19.5V11.5L26.9993 19.5H18.9993Z"
                        fill="#101214"
                    />
                    <path
                        d="M32.9991 18.5V36.5H16.9991V40.5H36.9991V18.5H32.9991Z"
                        fill="#101214"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5565_6299">
                    <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(-0.000976562 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
